import { Navigate } from 'react-router';
import Layout from '../components/layout/Layout';

const SuperAndAdminRoute = ({ isLogin }) => {
  return isLogin ? <Layout /> : <Navigate to='/' />;
};
export default SuperAndAdminRoute;
